import { Component, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AbilityService } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { noop } from 'lodash';
import {
  AlertComponent,
  ButtonComponent,
  CheckboxComponent,
  MbsPopupType,
  MbsSize,
  ModalComponent,
  ModalFooterDirective,
  ModalService
} from 'mbs-ui-kit';
import { TFARequireModalComponent } from 'mbs-ui-shared@components';
import { ApplicationStateFacade } from 'mbs-ui-shared@facades/application.facade';
import { UiStorageKey } from 'mbs-ui-shared@models';
import { EnablePasswordRecoveryWizardComponent } from 'mbs-ui-shared@modules/password-recovery/modals/enable-password-recovery-wizard/enable-password-recovery-wizard.component';

import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';

UntilDestroy();
@Component({
  selector: 'mbs-force-password-recovery',
  templateUrl: './force-password-recovery-modal.component.html',
  imports: [
    AlertComponent,
    ButtonComponent,
    CheckboxComponent,
    CommonModule,
    ReactiveFormsModule,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class ForcePasswordRecoveryModalComponent {
  private modalService = inject(ModalService);
  private ability = inject(AbilityService);
  private i18N = inject(I18NextPipe);
  private applicationStateFacade = inject(ApplicationStateFacade);

  public readonly mbsPopupType = MbsPopupType;
  public tryToClose = false;
  public warningCheckbox = new FormControl(false);
  public uiStorageKey = UiStorageKey.HidePasswordRecoveryModal;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  public onPasswordRecoveryEnableButtonClick() {
    if (this.ability.cannot('read', '2FAEnabled')) {
      this.modalService
        .openCustom(TFARequireModalComponent, {
          size: MbsSize.sm,
          data: {
            actionName: this.i18N.transform('shared:pass-recovery.passRecoveryTitle', { format: 'title' })
          }
        })
        .catch(noop);

      return;
    }

    this.modalService
      .openCustom(EnablePasswordRecoveryWizardComponent)
      .then(() => {
        this.baseModal.close();
      })
      .catch(noop);
  }

  public onCloseButtonClick(): void {
    if (!this.tryToClose) {
      this.tryToClose = true;
      return;
    }

    this.applicationStateFacade.updateStorageSetting(this.uiStorageKey, 'true', true).subscribe({
      complete: () => this.baseModal.close()
    });
  }
}
